import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE } from '../actions';

const initialState = {
  // The company-level view projected from the SubCompany (the single source).
  // Same flat shape the cert wizard reads, minus the cert-cycle fields.
  profile: null,
};

const subCompanyCompanyProfileReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE.GET_COMPANY_PROFILE:
        draft.profile = payload || null;
        break;

      case SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE.UPDATE_COMPANY_PROFILE_SECTION:
        if (draft.profile && payload?.section) {
          draft.profile[payload.section] = payload.data;
        }

        break;

      case SUB_COMPANY_COMPANY_PROFILE_ACTION_TYPE.RESET_COMPANY_PROFILE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyCompanyProfileReducer;
